import React from 'react';

export function useVariant() {
    const [variantConfig, setVariantConfig] = React.useState(
        () => window.bodapro?.variantConfig || null
    );

    React.useEffect(() => {
        if (variantConfig) return;
        window.bodapro?.getRunConfig?.().then(cfg => {
            setVariantConfig(cfg?.variant || null);
        });
    }, []);

    return variantConfig;
}
